<div class="modal-header blue">
  <h4 class="modal-title">
    {{
      isReadOnly
        ? 'Provider Group: ' + groupId
        : isEditMode
          ? 'Edit Provider Group: ' + groupId
          : 'Create Provider Group'
    }}
  </h4>
  <a
    href="javascript:void(0)"
    aria-label="javascript"
    class="modal-close-btn"
    (click)="close()"
  ></a>
</div>

<div class="modal-body" [class.loading]="isLoading">
  <ul
    ngbNav
    #nav="ngbNav"
    [destroyOnHide]="false"
    [(activeId)]="activeTabNumber"
    class="nav-tabs mb-3"
  >
    <li [ngbNavItem]="1">
      <a ngbNavLink>Provider Details</a>
      <ng-template ngbNavContent>
        <form class="filter-row h-100" [formGroup]="providerGroupForm">
          <div class="row h-100">
            <div class="flex-container col-10 pr-0">
              <div class="row">
                <div class="col-3">
                  <div class="mb-3">
                    <div class="input-label">
                      <span class="standart-text-required-symbol">* </span>
                      account number
                    </div>
                    <input
                      type="text"
                      placeholder="Enter Account Number"
                      class="input"
                      formControlName="accountNumber"
                    />
                  </div>
                  <div class="mb-3">
                    <div class="input-label">
                      <span class="standart-text-required-symbol">* </span>
                      name
                    </div>
                    <input
                      type="text"
                      placeholder="Enter Group Name"
                      class="input"
                      formControlName="name"
                      maxlength="65"
                    />
                  </div>
                  <div class="mb-3">
                    <div class="input-label">
                      <span class="standart-text-required-symbol">* </span>
                      fee schedule
                    </div>

                    <div
                      class="input-wrap select"
                      [class.disabled]="providerGroupForm.disabled"
                    >
                      <select
                        class="input"
                        formControlName="feeSchedule"
                        aria-label="feeSchedule"
                      >
                        <option [value]="''" selected="selected" disabled>
                          Select Fee Schedule
                        </option>
                        <option
                          *ngFor="let fee of fees"
                          [value]="fee.id"
                          [title]="fee.name"
                        >
                          {{ fee.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-3">
                    <ddl-practice
                      formControlName="pms"
                      *ngIf="!isClientAdmin"
                    ></ddl-practice>
                    <div class="input-label" *ngIf="isClientAdmin">
                      <span class="standart-text-required-symbol">* </span>
                      Practice Management
                    </div>
                    <div *ngIf="isClientAdmin">
                      {{ providerGroup?.pMSSoftware }}
                    </div>
                  </div>
                  <div
                    class="input-wrap"
                    [class.is-invalid]="
                      providerGroupForm.get('certified')?.touched &&
                      providerGroupForm.get('certified')?.invalid
                    "
                    [class.p-1]="
                      providerGroupForm.get('certified')?.touched &&
                      providerGroupForm.get('certified')?.invalid
                    "
                  >
                    <div class="input-label">
                      <span class="standart-text-required-symbol">* </span>
                      certification status
                    </div>
                    <div class="d-flex mt-1">
                      <radio
                        class="mr-3"
                        checkedValue="P"
                        formControlName="certified"
                        >Production</radio
                      >
                      <radio checkedValue="T" formControlName="certified"
                        >Test</radio
                      >
                    </div>
                    <div
                      class="invalid-feedback text-left"
                      *ngIf="
                        providerGroupForm.get('certified')?.invalid &&
                        providerGroupForm.get('certified')?.touched
                      "
                    >
                      <span>Please select certification status</span>
                    </div>
                  </div>
                </div>

                <!-- CONTACT SECTION -->
                <div class="col-3 modal-section pb-3">
                  <section-contact formGroupName="contact"></section-contact>
                </div>

                <!-- ADDRESS SECTION -->
                <div class="col-3 modal-section pb-3">
                  <section-address [size]="'small'" formGroupName="address">
                  </section-address>

                  <div class="mt-4 pt-1">
                    <checkbox
                      checkedValue="Y"
                      uncheckedValue="N"
                      formControlName="rcm"
                    >
                      RCM
                    </checkbox>
                  </div>

                  <div class="mt-4 pt-1">
                    <checkbox
                      checkedValue="Y"
                      uncheckedValue="N"
                      formControlName="genericProvider"
                    >
                      Generic Provider
                    </checkbox>
                  </div>
                </div>

                <!-- DATES SECTION-->
                <div class="col-3">
                  <!-- [(statusDatesValue)]="statusDateValue" -->
                  <section-status-dates
                    formGroupName="status"
                    [isEditMode]="isEditMode"
                  >
                  </section-status-dates>
                </div>
              </div>

              <div class="row md mb-3">
                <div class="col-2" *ngIf="isEditMode">
                  <div class="input-label">mailbox id</div>
                  <input
                    type="text"
                    placeholder="Enter MailBox Id"
                    class="input"
                    formControlName="mailboxId"
                    maxLength="6"
                  />
                </div>
                <div class="col-2">
                  <div class="input-label">lockbox</div>
                  <input
                    type="text"
                    placeholder="Enter LockBox"
                    class="input"
                    formControlName="lockBox"
                    maxlength="20"
                  />
                </div>
                <div class="col-3">
                  <div class="input-label">backlink</div>
                  <input
                    type="text"
                    placeholder="Enter Backlink"
                    class="input"
                    formControlName="backLink"
                    maxlength="70"
                  />
                </div>
                <div class="col-3">
                  <div class="input-label">Lockbox Processor id</div>
                  <input
                    type="text"
                    placeholder="Enter Processor Id"
                    class="input"
                    formControlName="lockboxProcessorId"
                    maxlength="12"
                  />
                </div>
              </div>
              <div class="row md">
                <div class="col pr-3">
                  <div class="input-label">Notes</div>
                  <div class="input-wrap">
                    <textarea
                      placeholder="Enter Notes"
                      formControlName="notes"
                      [attr.rows]="isEditMode ? 5 : 13"
                      maxlength="4000"
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- GRID SECTION -->
              <div class="standart-table-wrapper mt-3 pt-2">
                <providers-grid
                  [providers]="providers"
                  (create)="openProviderSetUp()"
                  (editComplete)="doProviderGridReload()"
                  (providersScroll)="doProviderGridScroll()"
                >
                </providers-grid>
              </div>
            </div>

            <!-- ENROLMENT SECTION -->
            <div class="col-2">
              <a
                href="javascript:void(0);"
                (click)="addGroupEnrollment()"
                class="add-group-btn mb-3"
                [class.disabled]="!providerGroup?.groupId || isReadOnly"
              >
                <i class="fas fa-plus fz-16 mr-2"></i>
                <span> Add Group Enrollment </span>
              </a>

              <section-batch-remittance [formGroup]="providerGroupForm">
              </section-batch-remittance>

              <div>
                <div class="input-label mb-2">Glue era</div>
                <div class="d-flex flex-wrap">
                  <radio class="mr-2" checkedValue="Y" formControlName="glueEM">
                    Combine ALL
                  </radio>
                  <radio class="mr-2" checkedValue="N" formControlName="glueEM"
                    >No</radio
                  >
                  <radio
                    class="mr-2 mt-2"
                    checkedValue="P"
                    formControlName="glueEM"
                    >By Payer</radio
                  >
                </div>
              </div>
            </div>
          </div>
        </form>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>Identifiers</a>
      <ng-template ngbNavContent>
        <qualifiers-grid
          [isReadOnly]="isReadOnly"
          [groupId]="groupId"
          [isProviderGroup]="true"
        >
        </qualifiers-grid>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a ngbNavLink>Processor</a>
      <ng-template ngbNavContent>
        <group-processor [formGroup]="providerGroupProcessorForm">
        </group-processor>
      </ng-template>
    </li>
    <li [ngbNavItem]="4" *ngxPermissionsOnly="'Financial Module'">
      <a ngbNavLink>Financial Settings</a>
      <ng-template ngbNavContent>
        <financials
          [isReadOnly]="isReadOnly"
          [formGroup]="providerGroupFinancialsForm"
          [groupId]="groupId"
        >
        </financials>
      </ng-template>
    </li>
  </ul>

  <div class="provider-group" [ngbNavOutlet]="nav" style="height: 674px"></div>
</div>

<div class="modal-footer">
  <button
    class="button ml-auto w-134px"
    *ngIf="!isReadOnly"
    [disabled]="providerGroupForm.invalid || isLoading"
    (click)="save()"
  >
    {{ isEditMode ? 'Save' : 'Add' }} & Close
  </button>
</div>

<ng-template #providerGroupIDLabel>
  <div class="input-text">
    {{ providerGroup?.groupId }}
  </div>
</ng-template>

<ng-template #emptyRow>
  <tr>
    <td colspan="4" class="pt-3 pb-3">
      <empty-state size="sm" title="No results found"></empty-state>
    </td>
  </tr>
</ng-template>
